import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {LocalStorageUtils} from "../../../infrastructure/utils/local-storage.utils";
import {LOCAL_STORAGE_KEYS, ROUTE_NAMES} from "../../../core/consts";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {WebsiteModuleController} from "../website-module.controller";
import {WEBSITE_MODULE} from "../website-module.consts";
import {WebsiteModuleConfig} from "../website-module.config";
import {UserSelectionsManager} from "../../../core/managers/user-selections.manager";
import {WEBSITE_MODULE_REMOTE_CONFIG} from "../website-module.remote-config";
import {WebsiteModuleState} from "../models/website-module.state";
import {PopupsDisplayManager} from "../../../core/managers/popups-display.manager";
import {POPUP_DISPLAY} from "../../../core/models/popup/consts";

export class WebsiteWidgetWizardAutoDisplayHandler extends ActionHandler {
  controller: WebsiteModuleController;
  state: WebsiteModuleState;
  userSelectionsManager: UserSelectionsManager;
  popupId: String = POPUP_DISPLAY.AUTO_DISPLAY_POPUPS.wizard;
  type = WEBSITE_MODULE.ACTION_TYPES.wizardWidgetAutoDisplayHandler;

  static injectables = [...ActionHandler.injectables, LocalStorageUtils, DatetimeUtils, UserSelectionsManager, PopupsDisplayManager];

  constructor(localStorageUtils: LocalStorageUtils, datetimeUtils: DatetimeUtils, userSelectionsManager: UserSelectionsManager, popupsDisplayManager: PopupsDisplayManager) {
    super();

    this.localStorageUtils = localStorageUtils;
    this.datetimeUtils = datetimeUtils;
    this.userSelectionsManager = userSelectionsManager;
    this.popupsDisplayManager = popupsDisplayManager;
  }

  onLoaded() {
    this.popupsDisplayManager.registerToChange(POPUP_DISPLAY.AUTO_DISPLAY_POPUPS.wizard,
        (params) => setTimeout(() => this.action(), params.delay * 1000)
    );

  }

  get config(): WebsiteModuleConfig {
    return this.controller.config;
  }

  get hasGDPRConsents(): Boolean {
    return !this.appStore.state.shouldSupportConsent || this.isCookiePolicyApproved;
  }

  async action(params) {
    let shouldRenderWizard;

    if (this.appStore.state.wizardDisplayModel.blockDisplay || !this.hasGDPRConsents) {
      shouldRenderWizard = false;
    }
    else{
      shouldRenderWizard = this.isRouteValid && this.isLastVisibleValid;

      shouldRenderWizard &= (!this.userHasSelections || this.isLastSelectionDateExpired);

      if (shouldRenderWizard) {
        this.localStorageUtils.set(LOCAL_STORAGE_KEYS.lastDateWizardWasVisible, new Date());
        //this.storeCountWizardAutoDisplay();

        this.appStore.state.wizardDisplayModel.isVisible = true;
      }
    }

    this.popupsDisplayManager.setPopupDisplayStatus(POPUP_DISPLAY.AUTO_DISPLAY_POPUPS.wizard, shouldRenderWizard)
  }

  // storeCountWizardAutoDisplay(): Number {
  //   let maxNumberOfDisplayStorageCount: String = this.localStorageUtils.get(LOCAL_STORAGE_KEYS.countWizardAutoDisplays) || 0;
  //   const maxNumberOfDisplayCount: Number = maxNumberOfDisplayStorageCount + 1;
  //
  //   this.localStorageUtils.set(LOCAL_STORAGE_KEYS.countWizardAutoDisplays, maxNumberOfDisplayCount);
  //
  //   return maxNumberOfDisplayCount;
  // }

  get isReturnedUser() {
    return this.localStorageUtils.get(LOCAL_STORAGE_KEYS.isReturnedUser);
  }

  get isCookiePolicyApproved() {
    return this.localStorageUtils.get(LOCAL_STORAGE_KEYS.cookiePolicyApproved);
  }

  get bettingPromotionValidVisibility() {
    return this.appStore.state.appBettingPromotionDisplayModel.isValidVisibility;
  }

  get userHasSelections(): Boolean {
    const hasCompetitors: Boolean = !!this.userSelectionsManager.competitorsIds.length;
    const hasCompetitions: Boolean = !!this.userSelectionsManager.competitionsIds.length;
    const userHasSelections: Boolean = hasCompetitors || hasCompetitions;

    return userHasSelections;
  }

  get isLastSelectionDateExpired(): Boolean {
    let isLastSelectionDateExpired;

    const lastUserSelection = this.localStorageUtils.get(LOCAL_STORAGE_KEYS.lastUserSelectionDate);

    if (!lastUserSelection) {
      isLastSelectionDateExpired = true;
    } else {
      const lastUserSelectionDate = new Date(lastUserSelection);
      const differentByDays = this.datetimeUtils.diffDaysByDate(new Date(), lastUserSelectionDate);
      const daysWithoutSelectionsActivity: Number = this.config.getValue(WEBSITE_MODULE_REMOTE_CONFIG.DAYS_WITHOUT_SELECTION_ACTIVITY);

      isLastSelectionDateExpired = differentByDays >= daysWithoutSelectionsActivity;
    }

    return isLastSelectionDateExpired;
  }

  get isRouteValid(): Boolean {
    const entityScreenTypes: Array<ROUTE_NAMES> = [ROUTE_NAMES.allScores, ROUTE_NAMES.myScoresPage, ROUTE_NAMES.competitorScores, ROUTE_NAMES.competitionScores];

    return this.navigationManager.currentLinkModel && entityScreenTypes.includes(this.navigationManager.currentLinkModel.name);
  }

  get isLastVisibleValid(): Boolean {
    let isLastVisibleValid;

    const isLastVisibleStorageDate = this.localStorageUtils.get(LOCAL_STORAGE_KEYS.lastDateWizardWasVisible);
    if (!isLastVisibleStorageDate) {
      isLastVisibleValid = true;
    } else {
      const isLastVisibleDate: Date = new Date(isLastVisibleStorageDate);
      isLastVisibleValid = !this.datetimeUtils.isToday(isLastVisibleDate);
    }

    return isLastVisibleValid;
  }
}
